export const set_report = (state, report) => (state.report = report);
export const set_reports = (state, reports) => (state.reports = reports);
export const set_question = (state, question) => (state.question = question);
export const set_questions = (state, questions) =>
  (state.questions = questions);
export const set_user_categories = (state, categories) =>
  (state.user_categories = categories);
